import { render, staticRenderFns } from "./DictItemMultipleSelect.vue?vue&type=template&id=73abcd46&scoped=true"
import script from "./DictItemMultipleSelect.vue?vue&type=script&lang=js"
export * from "./DictItemMultipleSelect.vue?vue&type=script&lang=js"
import style0 from "./DictItemMultipleSelect.vue?vue&type=style&index=0&id=73abcd46&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73abcd46",
  null
  
)

export default component.exports